import { composedParentElement } from 'utils/core'

export const isRangeVisible = (range: Range) => {
  const { startContainer, endContainer } = range

  const isNodeVisible = (node: Node): boolean => {
    let current: Node | null = node

    while (current && current.nodeType !== Node.DOCUMENT_NODE) {
      if (current.nodeType === Node.TEXT_NODE) {
        current = composedParentElement(current)
        continue
      }

      if (current instanceof Element) {
        const style = getComputedStyle(current)

        if (style.display === 'none' || style.visibility === 'hidden') {
          return false
        }
      }

      current = composedParentElement(current)
    }

    return true
  }

  return isNodeVisible(startContainer) && isNodeVisible(endContainer)
}
